import { api, loginapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const LogoutAPIs = {

    
    PostLogout: async function ( cancel = false){
        const response = await api.request({
            url: '/logout',
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-authc-username-password+json',
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    
}
const cancelAPIObject = defineCancelApiObject(LogoutAPIs)